import { render, staticRenderFns } from "./System.vue?vue&type=template&id=41a0067a&scoped=true"
import script from "./System.vue?vue&type=script&lang=js"
export * from "./System.vue?vue&type=script&lang=js"
import style0 from "./System.vue?vue&type=style&index=0&id=41a0067a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a0067a",
  null
  
)

export default component.exports